import { Typography } from "@stardust-ds/react"

export default function RcmpFormErrorMessage(props) {
    const { children, ...oRest } = props
    return (
        <Typography color="#FF3541" type="p3" {...oRest}>
            {children}
        </Typography>
    )
}
